<template>
  <div class="tab-content">
    <LoadingIcon
      v-if="isLoading"
      size="lg"
    />

    <div
      v-if="!isLoading"
      class="mb-4"
    >
      <UserSubscriptionDetails v-if="subscription.has_access" />

      <AlertBox v-if="subscription.is_pending">
        <b>Assinatura aguardando pagamento</b>
        <p>Assim que seu pagamento for compensado sua assinatura será ativada automaticamente</p>
      </AlertBox>
      
      <SubscriptionAdvertising v-if="!subscription.has_access && !subscription.is_pending" />
      
      <SectionTitle class="mt-3">
        <h5>Cursos comprados</h5>
      </SectionTitle>
      
      <UserPurchases />
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import SubscriptionAdvertising from '@/components/purchase/SubscriptionAdvertising'
  import UserSubscriptionDetails from '@/components/user/profile/UserSubscriptionDetails'
  import UserPurchases from '@/components/user/profile/UserPurchases'
  import SectionTitle from '@/components/text/titles/SectionTitle'
  import LoadingIcon from '@/components/layout/LoadingIcon'
  import AlertBox from '@/components/layout/AlertBox'

  export default {
    components: {
      SubscriptionAdvertising,
      UserSubscriptionDetails,
      SectionTitle,
      UserPurchases,
      LoadingIcon,
      AlertBox,
    },

    data: () => ({
      isLoading: false
    }),

    async mounted () {
      await this.fetchMyPurchases()
    },

    computed: {
      ...mapGetters('subscription', ['subscription'])
    },

    methods: {
      ...mapActions('purchase', ['fetchMyPurchases']),
    }
  }
</script>
